<boi-main-layout class="mortgage-application" [hasStickHeader]="true" [scrollStickyHeaderHeight]="180">
  <div boiStickyHeader secondaryHeader class="mortgage-application-page">
    <boi-case-summary-header [logoPath]="mortgageApplication?.PropositionLogoPath"
      [model]="mortgageApplication?.ApplicationCase"
      [headerTextName]="mortgageApplication?.IsFullApp ? referenceDataLabels.MortgageApplicationId : (mortgageApplication?.IsFactFind ? referenceDataLabels.FactFind : referenceDataLabels.AIP)"
      [displayAdviceTabLink]="mortgageApplication?.IsFactFind" [displayAddApplicantLink]="canAddApplicant">
    </boi-case-summary-header>
    <div class="menu sticky-content">
      <nav class="app-tabs">
        <boi-form-application-tab [label]="referenceDataLabels.SectionTitleMortgage|localizeLabel"
          [routerLink]="['/application',applicationId,'yourMortgage']"
          [hasSubmitValidationError]="hasSubmitValidationError" [progress]="sections?.YourMortgage?.Progress"
          [cssClass]="'mortgage'">
        </boi-form-application-tab>

        <boi-form-application-tab
          *ngFor="let applicant of mortgageApplication?.Applicants; let i = index; trackBy: trackByApplicantTransactOrder"
          [label]="getLabel(applicant)" [routerLink]="['/application', applicationId, 'applicant',i]"
          [hasSubmitValidationError]="hasSubmitValidationError"
          [progress]="sections?.Applicant[i] ? sections?.Applicant[i]?.Progress : undefined" [cssClass]="'applicant'"
          [tabOrderNumber]="isApplicantOrderVisible() ? applicant.ApplicantTransactOrder : 0">
        </boi-form-application-tab>

        <boi-form-application-tab *ngIf="mortgageApplication?.IsFullApp || mortgageApplication?.IsFactFind"
          [label]="referenceDataLabels.SectionTitleOutgoings|localizeLabel"
          [routerLink]="['/application',applicationId,'yourOutgoings']"
          [hasSubmitValidationError]="hasSubmitValidationError" [progress]="sections?.YourOutgoings?.Progress"
          [cssClass]="'outgoings'">
        </boi-form-application-tab>

        <boi-form-application-tab [label]="referenceDataLabels.SectionTitleProperty|localizeLabel"
          [routerLink]="['/application',applicationId,'yourProperty']"
          [hasSubmitValidationError]="hasSubmitValidationError" [progress]="sections?.YourProperty?.Progress"
          [cssClass]="'property'">
        </boi-form-application-tab>

        <boi-form-application-tab *ngIf="isFactFind2Visible" [label]="referenceDataLabels.TabFactFind2|localizeLabel"
          [routerLink]="['/application',applicationId,'factFind2']"
          [hasSubmitValidationError]="hasSubmitValidationError" [progress]="sections?.FactFind2?.Progress"
          [cssClass]="'ff2'">
        </boi-form-application-tab>
      </nav>
    </div>
  </div>

  <div leftPageContent>
    <router-outlet></router-outlet>
    <ng-container
      *ngIf="router.url.includes('declaration') && mortgageApplication?.IsFullApp && !mortgageApplication?.IsApplicationReadOnly">
      <button (click)="submitApplication()" class="submit-app-button left-side vo-primary-button-1"
        [innerHTML]="referenceDataLabels.Submit|localizeLabel" [disabled]="mortgageApplication?.IsApplicationReadOnly"
        [boiPermissionChecker]="[userPermissions.SubmitApp]">
      </button>
    </ng-container>
  </div>

  <div rightPageContent>
    <ng-container *ngIf="!router.url.includes('declaration')">
      <boi-progress-stepper [sections]="sections" [activeTab]="activeTab"
        [hasSubmitValidationError]="hasSubmitValidationError"></boi-progress-stepper>
    </ng-container>

    <ng-container *ngIf="canCheckAffordability && !mortgageApplication?.IsFactFindReadOnly && activeTab?.key !== 'factFind2'">
      <button (click)="performAffordability()" class="primary-button"
        [innerHTML]="referenceDataLabels.AffordabilityCheckButton|localizeLabel"
        [boiPermissionChecker]="[userPermissions.SubmitApp]">
      </button>
    </ng-container>

    <ng-container
      *ngIf="!router.url.includes('declaration') && mortgageApplication?.IsFullApp && !mortgageApplication?.IsApplicationReadOnly">
      <button (click)="goToDeclaration()" class="submit-app-button"
        [innerHTML]="referenceDataLabels.ProceedToDeclaration|localizeLabel"
        [boiPermissionChecker]="[userPermissions.SubmitApp]">
      </button>
    </ng-container>

    <ng-container *ngIf="mortgageApplication?.IsApplicationReadOnly && !router.url.includes('declaration')">
      <div (click)="goToCaseSummary()" class="link" [innerHTML]="referenceDataLabels.GoBackToCaseSummary|localizeLabel">
      </div>

      <div (click)="proceedToDeclaration()" class="link" *ngIf="mortgageApplication?.IsFullApp"
        [innerHTML]="referenceDataLabels.ReadDeclaration|localizeLabel">
      </div>
    </ng-container>

    <ng-container
      *ngIf="router.url.includes('declaration') && mortgageApplication?.IsFullApp && !mortgageApplication?.IsApplicationReadOnly">
      <button (click)="submitApplication()" class="submit-app-button"
        [innerHTML]="referenceDataLabels.Submit|localizeLabel" [boiPermissionChecker]="[userPermissions.SubmitApp]">
      </button>
    </ng-container>

    <ng-container *ngIf="mortgageApplication?.IsAip && !mortgageApplication?.IsApplicationReadOnly">
      <button (click)="submitAip()" class="submit-app-button" [innerHTML]="referenceDataLabels.Submit|localizeLabel"
        [boiPermissionChecker]="[userPermissions.SubmitAip]">
      </button>
    </ng-container>

    <ng-container
      *ngIf="this.showValidateFactFind1Btn()">
      <button (click)="validateFactFind1()" class="submit-app-button"
        [innerHTML]="referenceDataLabels.SubmitFactFind|localizeLabel"
        [boiPermissionChecker]="[userPermissions.SubmitAip]">
      </button>
    </ng-container>

    <ng-container
      *ngIf="activeTab.key === 'factFind2' && mortgageApplication?.IsFactFind && !mortgageApplication?.IsApplicationReadOnly">
      <button (click)="submitFactFind2()" class="submit-app-button"
        [innerHTML]="referenceDataLabels.Submit|localizeLabel">
      </button>
    </ng-container>

    <boi-contextual-help-displayer></boi-contextual-help-displayer>
  </div>
</boi-main-layout>

<ng-container *ngIf="isHardCreditWarningDialogOpened">
  <boi-hard-credit-warning-dialog class="vo-modal vo-modal--standard" [(opened)]="isHardCreditWarningDialogOpened" (confirmAction)="submitApplication()">
  </boi-hard-credit-warning-dialog>
</ng-container>

<ng-container *ngIf="isSoftCreditWarningDialogOpened">
  <boi-soft-credit-warning-dialog class="vo-modal vo-modal--standard" [(opened)]="isSoftCreditWarningDialogOpened" (confirmAction)="submitFactFind1()">
  </boi-soft-credit-warning-dialog>
</ng-container>

<ng-container *ngIf="isApplicantOrderWarningDialogOpened">
  <boi-applicant-order-warning-dialog class="vo-modal vo-modal--large" [(opened)]="isApplicantOrderWarningDialogOpened" (confirmAction)="openSoftCreditWarningDialog()">
  </boi-applicant-order-warning-dialog>
</ng-container>

<ng-container *ngIf="isAffordabilityWarningDialogOpened">
  <boi-affordability-warning-dialog class="vo-modal vo-modal--standard" [(opened)]="isAffordabilityWarningDialogOpened"
    [data]="affordabilityValidationErrors">
  </boi-affordability-warning-dialog>
</ng-container>

<ng-container *ngIf="isAffordabilityDialogOpened">
  <boi-affordability-results-dialog class="vo-modal vo-modal--standard" [(opened)]="isAffordabilityDialogOpened"
    [titleLabel]="referenceDataLabels.AffordabilityResult" [data]="affordabilityResults">
  </boi-affordability-results-dialog>
</ng-container>

<ng-container *ngIf="isFeesKfiNotFoundDialogOpened">
  <boi-confirmation-dialog class="vo-modal vo-modal--standard" [(opened)]="isFeesKfiNotFoundDialogOpened"
    [titleLabel]="referenceDataLabels.NoFeesKfiFoundNotificationTitle"
    [confirmationLabel]="referenceDataLabels.NoFeesKfiFoundNotificationContent"
    [confirmationButtonLabel]="referenceDataLabels.Continue" (confirmAction)="proceedToDeclaration()">
  </boi-confirmation-dialog>
</ng-container>
